const dpi = () => {
    let div = document.createElement("div");
    div.style.height = "1in";
    div.style.visibility = "hidded";
    document.body.appendChild(div);
    let result = div.offsetHeight;
    document.body.removeChild(div);
    return result;
};

export default dpi;
